import { mapMutations } from 'vuex';

import { STATISTICS_TYPES } from '@/utils/constants';
import {
  GroupBuyingStatistics,
  GroupBuyingDetails,
  MemberStatistics,
  MemberDetails,
} from '@/components/Statistics';
import {
  SET_MEMBER_REPORT_RANGE,
  SET_SEARCH_DATE_TYPE,
} from '@/store/reports/constants';

export default {
  name: 'Statistics',
  computed: {
    component() {
      const { type, id } = this.$route.params;

      if (type === STATISTICS_TYPES.MEMBER) {
        if (id) {
          return MemberDetails;
        }
        return MemberStatistics;
      }

      /* Default to group buying mode */
      if (id) {
        return GroupBuyingDetails;
      }
      return GroupBuyingStatistics;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    ...mapMutations('reports', {
      setReportRange: SET_MEMBER_REPORT_RANGE,
      setSearchDateType: SET_SEARCH_DATE_TYPE,
    }),
  },
  beforeDestroy() {
    this.setReportRange([]);
    this.setSearchDateType('start');
  },
};
